import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-report",
  "use": "icon-report-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-report\"><defs><style type=\"text/css\"></style></defs><path d=\"M102.4 51.2V1024H0V51.2C0 23.2 23.2 0 51.2 0c28 0 51.2 23.2 51.2 51.2z\" p-id=\"24903\" /><path d=\"M0 921.6h972.8c28 0 51.2 23.2 51.2 51.2 0 28-23.2 51.2-51.2 51.2H0v-102.4zM187.2 574.4h204v240.8H187.2zM481.6 82.4h204V816H481.6zM776 329.6h204v485.6H776z\" p-id=\"24904\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol